export const PROVIDER_COUNT_BY_COUNTRY: Record<string, number> = {
    AT: 2,
    AX: 1,
    BE: 3,
    BG: 3,
    CZ: 5,
    DE: 2,
    DK: 3,
    EE: 4,
    ES: 3,
    FI: 4,
    FR: 2,
    GR: 1,
    HR: 3,
    HU: 14,
    IE: 2,
    LT: 4,
    LU: 2,
    LV: 4,
    NL: 2,
    NO: 3,
    PL: 5,
    PT: 2,
    RO: 7,
    RS: 3,
    SE: 3,
    SI: 4,
    SK: 6,
};

/** One full row at the `md` breakpoint. Used when the shop's country is unknown or unmapped. */
export const DEFAULT_PROVIDER_COUNT = 3;
